import { z } from "zod";

export const CreateUserBankAccountFormSchema = z.object({
  name: z.string(),
  email: z.string().email(),
  cardNumber: z
    .string()
    .regex(/^(\d{4}\s?){3}\d{4}$/, { message: "Número do cartão inválido" }),
  expirationDate: z.string().regex(/^(0[1-9]|1[0-2])\/([0-9]{2})$/, {
    message: "Data de expiração inválida",
  }),
  cvv: z.string().regex(/^\d{3,4}$/, { message: "CVV inválido" }),
  saveCard: z.boolean().default(false),
});
